<template>
    <!--   <v-container :loading="loading">
           <v-page-title title="Жалобы пользователя" :to="{ name: 'admin-promotion-user', params: { id: id } }" />
           <v-cover>
               <v-table
                   @paginate="load"
                   :desktop-headers="listDesktopHeaders"
                   :mobile-headers="listMobileHeaders"
                   :items="items"
               >
                   <template #desktop="item">
                       <td>{{ item.index }}</td>
                       <td>
                           <a :href="item.post_url" target="_blank">{{ item.post_url }}</a>
                       </td>
                       <td>{{ item.authentication_id }} {{ item.first_name }} {{ item.last_name }}</td>
                       <td>{{ item.reason }}</td>
                       <td>
                           <button @click.prevent="removeComplaint(item.id)" style="margin-bottom: 5px;display: block;">
                               Снять жалобу
                           </button>
                       </td>
                   </template>
                   <template #mobileHeader="item">
                       <v-table-mobile-header>
                           <a :href="item.post_url" target="_blank">{{ item.post_url }}</a>
                       </v-table-mobile-header>
                       <v-table-mobile-header>
                           {{ item.authentication_id }} {{ item.first_name }} {{ item.last_name }}
                       </v-table-mobile-header>
                   </template>
                   <template #mobile="item">
                       <v-table-mobile-item title="Причина">
                           {{ item.reason }}
                       </v-table-mobile-item>
                       <v-table-mobile-item title="">
                           <v-button @click.prevent="removeComplaint(item.id)">Снять жалобу</v-button>
                       </v-table-mobile-item>
                   </template>
               </v-table>
           </v-cover>
       </v-container>-->
    <div>
        <v-page-title title="Жалобы пользователя" :to="{ name: 'admin-promotion-user', params: { id: id } }" />
        <v-table
            @paginate="load"
            :desktop-headers="listDesktopHeaders"
            :mobile-headers="listMobileHeaders"
            :items="items"
        >
            <template #desktop="item">
                <td>{{ item.index }}</td>
                <td>
                    <a :href="item.post_url" target="_blank">{{ item.post_url }}</a>
                </td>
                <td>{{ item.authentication_id }} {{ item.first_name }} {{ item.last_name }}</td>
                <td>{{ item.reason }}</td>
                <td>
                    <button @click.prevent="removeComplaint(item.id)" style="margin-bottom: 5px;display: block;">
                        Снять жалобу
                    </button>
                </td>
            </template>
            <template #mobileHeader="item">
                <v-table-mobile-header>
                    <a :href="item.post_url" target="_blank">{{ item.post_url }}</a>
                </v-table-mobile-header>
                <v-table-mobile-header>
                    {{ item.authentication_id }} {{ item.first_name }} {{ item.last_name }}
                </v-table-mobile-header>
            </template>
            <template #mobile="item">
                <v-table-mobile-item title="Причина">
                    {{ item.reason }}
                </v-table-mobile-item>
                <v-table-mobile-item title="">
                    <v-button @click.prevent="removeComplaint(item.id)">Снять жалобу</v-button>
                </v-table-mobile-item>
            </template>
        </v-table>
    </div>
</template>

<script>
import { api } from "../../services/api";

export default {
    name: "PromotionUserСomplaintsToUser",
    mounted() {
        this.load();
    },
    data() {
        return {
            loading: false,
            items: {
                data: [],
                total: 0,
                last_page: 0,
                current_page: 0
            }
        };
    },
    computed: {
        id() {
            return this.$route.params.id;
        },
        listDesktopHeaders() {
            return ["#", "Пост", "На кого пожаловался", "Причина", ""];
        },
        listMobileHeaders() {
            return ["#", "Пост", "На кого пожаловался"];
        }
    },
    methods: {
        load(page = 1) {
            this.$set(this, "loading", true);
            api.promotion.complaintsFromUser
                .list(this.id, { page })
                .then(({ data }) => {
                    this.$set(this.items, "data", data.data);
                    this.$set(this.items, "current_page", data.current_page);
                    this.$set(this.items, "last_page", data.last_page);
                    this.$set(this.items, "per_page", data.per_page);
                    this.$set(this.items, "total", data.total);
                })
                .finally(() => {
                    this.$set(this, "loading", false);
                });
        },
        removeComplaint(id) {
            if (!this.loading) {
                this.$set(this, "loading", true);
                api.promotion.complaintsFromUser
                    .removeComplaint(id)
                    .then(() => {
                        this.$set(this, "loading", false);
                        this.load();
                    })
                    .finally(() => {
                        this.$set(this, "loading", false);
                    });
            }
        }
    }
};
</script>

<style scoped></style>
